import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'institutions' })
export class Institution extends HierarchyNode {
  get htmlPageUrl(): string {
    return '/';
  }
}
